module.exports = __webpack_public_path__ + "ca1244a46ea63a8add51471cc27ddb2b.svg";